(() => {
  const ruhig = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const binde = (w) => {
    if (w.__sbw) return;
    w.__sbw = true;
    const z = [...w.querySelectorAll('.sbw__zitat')];
    if (z.length < 2 || ruhig) return;
    let i = 0, uhr = null, halt = false;
    w.classList.add('sbw--an');
    z[0].classList.add('is-an');
    const weiter = () => { z[i].classList.remove('is-an'); i = (i + 1) % z.length; z[i].classList.add('is-an'); };
    const lauf = (an) => { clearInterval(uhr); if (an && !halt) uhr = setInterval(weiter, 4200); };
    w.addEventListener('mouseenter', () => { halt = true; lauf(false); });
    w.addEventListener('mouseleave', () => { halt = false; lauf(true); });
    new IntersectionObserver(([x]) => lauf(x.isIntersecting), { threshold: .3 }).observe(w);
  };
  const alle = (ort) => (ort || document).querySelectorAll('[data-sbw]').forEach(binde);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => alle());
  else alle();
  document.addEventListener('shopify:section:load', (e) => alle(e.target));
})();
